import {reactFetchJSON} from '@github-ui/verified-fetch'
import {useMutation} from '@github-ui/react-query'

type RequestBody = {
  path: string
  viewed?: 'viewed'
  _method?: 'delete'
}
type Callbacks = {
  onSuccess: () => void
  onError: (e: Error) => void
}

export function useUpdateFileViewedStatusMutation(basePath: string, {onSuccess, onError}: Callbacks) {
  const apiURL = `${basePath}/file_review`

  return useMutation({
    mutationFn: async ({viewedStatus, path}: {viewedStatus: boolean; path: string}) => {
      const body: RequestBody = {
        path,
        viewed: viewedStatus ? 'viewed' : undefined,
        _method: viewedStatus ? undefined : 'delete',
      }

      const result = await reactFetchJSON(`${apiURL}`, {
        method: viewedStatus ? 'POST' : 'DELETE',
        headers: {
          Accept: 'application/json',
        },
        body,
      })
      const json = await result.json()
      if (result.ok) return json
      const errorMessage = json.error || 'Unknown error occurred'
      throw new Error(errorMessage, {cause: result.status})
    },
    onSuccess: () => {
      onSuccess()
    },
    onError: (e: Error) => {
      onError(e)
    },
  })
}
